export default __webpack_public_path__ + "locales/ro/Article.json?hash=84427376b4d8b73965c5c6100fd40941";